/**
 * Exposes Amplitude analytics to the global window object
 * This allows other client-side services to access window.amplitude
 */ import * as amplitude from '@amplitude/analytics-browser';
export function exposeAmplitudeGlobally() {
    //okay so i want to expose the ampltiude's object identify and track method globally
    if (typeof window !== 'undefined') {
        window.cheggAmplitude = {
            /**
       * Send an event to Amplitude
       * @param eventNameOrEvent - Event name string or BaseEvent object
       * @param eventProperties - Optional event properties
       */ sendEvent: ({ eventNameOrEvent, eventProperties = {} })=>{
                if (typeof amplitude !== 'undefined') {
                    if (typeof amplitude.track !== 'undefined') {
                        if (typeof eventNameOrEvent === 'string') {
                            // Simple signature: track(eventName, eventProperties)
                            amplitude.track(eventNameOrEvent, eventProperties);
                        } else {
                            // BaseEvent signature: track(baseEvent)
                            amplitude.track(eventNameOrEvent);
                        }
                    } else {
                        console.error('Amplitude track method is not initialized');
                    }
                } else {
                    console.error('Amplitude is not initialized');
                }
            },
            /**
       * Set user properties in amplitude
       * @param properties - User properties to set
       */ setUserProperties: (properties)=>{
                if (typeof amplitude !== 'undefined') {
                    if (typeof amplitude.identify !== 'undefined') {
                        const eventIdentify = new amplitude.Identify();
                        for (const [key, value] of Object.entries(properties)){
                            eventIdentify.set(key, value);
                        }
                        amplitude.identify(eventIdentify);
                    } else {
                        console.error('Amplitude identify method is not initialized');
                    }
                } else {
                    console.error('Amplitude is not initialized');
                }
            },
            /**
       * Add a custom enrichment plugin to Amplitude
       * Consumers can build their own Plugin to enrich all events
       */ addPlugin: (plugin)=>{
                if (typeof amplitude === 'undefined') {
                    console.error('Amplitude is not initialized');
                    return;
                }
                try {
                    const client = typeof amplitude.getInstance === 'function' ? amplitude.getInstance() : amplitude;
                    if (typeof client.add === 'function') {
                        client.add(plugin);
                    } else {
                        console.error('Amplitude add method is not available');
                    }
                } catch (error) {
                    console.error('Failed to add Amplitude plugin', error);
                }
            }
        };
    }
}
